import { GridView } from '@mui/icons-material';
import type { CustomWidgetDescription } from 'components/management/customDashboard/CustomWidgetDescription.types.ts';
import { useWidgetState } from 'components/management/customDashboard/CustomWidgetContext.tsx';
import { TradingActivityWidgetSettings, type TradingActivityWidgetState } from './TradingActivityWidgetSettings.tsx';
import { getDefaultRange, getRangeByLabel } from 'components/predefinedDateRanges.ts';
import { TradingActivityReportContainer } from './TradingActivityDashboard.tsx';

const createTradingActivityPresetKey = (id: string) => `customWidget/tradingActivity/${id}`;

export const tradingActivityWidget: CustomWidgetDescription = {
  name: 'Trading activity',
  type: 'tradingActivity',
  description: 'List of trading activities with date range filtering',
  icon: () => <GridView />,
  viewComponent: ({ id }) => {
    const initialState = useWidgetState<TradingActivityWidgetState>(id);
    const range = getRangeByLabel(initialState.predefinedDateRange) ?? getDefaultRange();
    const dateRange = range.value();
    return (
      <TradingActivityReportContainer presetSettingsKey={createTradingActivityPresetKey(id)} dateRange={dateRange} />
    );
  },
  settingsComponent: (props) => (
    <TradingActivityWidgetSettings {...props} presetKey={createTradingActivityPresetKey(props.id)} />
  ),
  initialState: {
    title: 'Trading activity',
    predefinedDateRange: '7D',
  } satisfies TradingActivityWidgetState,
  initialH: 6,
  initialW: 4,
};
